import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

export default function useGetUser() {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  return user;
}
